module.exports = __webpack_public_path__ + "img/symbol_12.ea774af8.png";